import React, { memo } from 'react'

const CalendarCellComponent = memo(
  ({
    date,
    width,
    content,
    backgroundColor,
    contentColor,
    cursor,
    opacity,
    onClick,
    innerRef,
  }: {
    date: string
    width: string
    content?: string | JSX.Element
    contentColor?: string
    backgroundColor: string
    cursor: React.CSSProperties['cursor']
    opacity?: string
    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
    innerRef?: (el: HTMLDivElement | null) => void
  }) => {
    return (
      <div
        ref={innerRef}
        className={`h-[70px] px-0.5 sm:px-2 flex flex-col items-center justify-start text-[10px] sm:text-xs ${opacity}`}
        style={{ width, cursor }}
        onClick={onClick}
      >
        <div className='flex flex-col items-center w-full h-full' style={{ backgroundColor }}>
          <div className='w-[80%]' style={{ borderTop: `2px solid ${contentColor}`, cursor }} />
          <div style={{ color: 'black' }} className='py-0.5 sm:py-1 text-xs sm:text-sm'>
            {date.split('-')[2]}
          </div>
          {typeof content === 'string' ? (
            <div
              className={`truncate px-2 max-w-full`}
              style={{ color: contentColor, fontWeight: 500 }}
              data-testid='remain-testid'
            >
              {content}
            </div>
          ) : (
            <div>{content && React.cloneElement(content, { color: contentColor })}</div>
          )}
        </div>
      </div>
    )
  },
)

CalendarCellComponent.displayName = 'CalendarCellComponent'

export default CalendarCellComponent
